import React, { useState } from "react";

const faqData = [
  {
    question: "Plateforme IA dédiée à LinkedIn",
    answer:
      "Analysez, mesurez et comparez vos performances LinkedIn grâce à une intelligence artificielle.",
  },
  {
    question: "Recommandations personnalisées & benchmark sectoriel",
    answer:
      "Des recommandations basées sur les données de votre secteur pour optimiser votre contenu et votre portée.",
  },
  {
    question: "Accompagnement humain & pilotage des performances",
    answer:
      "Nos experts vous accompagnent pour piloter vos campagnes, définir vos KPI et maximiser votre ROI.",
  },
];

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-20 lg:py-[120px]">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl font-bold text-dark sm:text-[40px]">
            Notre Value proposition
          </h2>
          <p className="text-base text-gray-600 mt-4">
            Tout ce que vous devez savoir sur notre solution IA pour LinkedIn.
          </p>
        </div>
        <div className="max-w-2xl mx-auto space-y-6">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-gray-200 p-5 shadow-md"
            >
              <button
                onClick={() => toggle(index)}
                className="flex items-center justify-between w-full text-left"
              >
                <h3 className="text-lg font-semibold text-dark">
                  {item.question}
                </h3>
                <span className="text-primary text-xl">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>
              {openIndex === index && (
                <p className="mt-4 text-base text-gray-600">{item.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
